import { action as apiAction } from 'api/Api'
import {
  add as addCard,
} from '../redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  name: string
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { cardId, name } = payload

  const state = getState()

  const card = state['view-board'].cards[cardId]

  let optimisticAction
  if (card) {
    const tempId = `temp-${new Date().getTime()}`

    optimisticAction = optimisticDispatch(dispatch, addCard({
      ...card,
      id: tempId,
      name: name.trim(),
      isBusy: true,
      position: card.listId ? card.position + 100 : undefined,
      statusPosition: card.statusPosition + 100,
    }))
  }

  try {
    await apiAction('CopyCard', {
      cardId,
      name: name.trim(),
    })
  } finally {
    optimisticAction?.revert()
  }
}
